var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('router-view',{attrs:{"name":"header"}}),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}}),_c('ModalOrdine',{ref:"modalOrdine"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }